import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router';
import { DropDownFormatter } from '../../Entities/DropDownFormatter.ts';
import { Modal } from '../Modal/modal-component';
import { LoadingAnimation } from '../Progress/progress-component';
import DropDownItem from './drop-down-item-component';
import useClickOutside from '../../Hooks/useClickOutside.js';

function DropDown(props) {

  const [visible, setVisible] = useState(false);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const loading = useSelector((state) => state.loading);
  const dropDownRef = useRef(null);

  const buttonDropDown = props.buttonDrop || [];
  const additionalInfo = props.infoDrop || [];
  const headerDropdown = props.headerDrop || new DropDownFormatter();
  const bodyDropdown = props.bodyDrop || new DropDownFormatter();
  const bottomDropdown = props.bottomDrop || new DropDownFormatter();
  const isAutoLogOut = props.isAutoLogOut;


  // Call setVisible(false) when clicking outside the dropdown
  useClickOutside(dropDownRef, () => setVisible(false));


  const handleTriggerHeader = async (e) => {
    e.preventDefault();
    console.log("called from parent header");
    headerDropdown?.trigger(e);
  };

  const handleTriggerBody = async (e) => {
    e.preventDefault();
    console.log("called from parent body");
    bodyDropdown?.trigger(e);
  };

  const handleTriggerBottom = async (e) => {
    e.preventDefault();
    console.log("called from parent bottom");
    bottomDropdown?.trigger(e);
  };


  if (!isAuthenticated) {
    if (isAutoLogOut) {
      console.log('logged out');
      return <Navigate to={'/'} replace />
    }
    return <div></div>
  }

  <Modal expand={loading.visible}>
    <LoadingAnimation loadingMessage={loading.message} />
  </Modal>


  return (
    <div ref={dropDownRef} className='relative'>
      <button type="button" className="flex mx-3 " id="user-menu-button" aria-expanded="false" onClick={(e) => { e.preventDefault(); setVisible(!visible) }}>
        {buttonDropDown.name && <div className='px-2 text-lg tracking-tight text-gray-700 md:text-sm lg:text-lg dark:text-gray-400'>{buttonDropDown.name}</div>}
        {buttonDropDown.logo ? <svg className="mr-2 w-5 h-5 text-gray-400 align-middle justify-center" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d={buttonDropDown.logo}></path></svg> : ''}
      </button>
      <div className={`${visible ? '' : 'hidden'} absolute right-0 mt-2 z-50 my-4 w-56 text-base list-none bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600`} id="dropdown">

        {additionalInfo && <div className="py-3 px-4">
          <span className="block text-sm font-semibold text-gray-900 dark:text-white">{additionalInfo[0]}</span>
          <span className="block text-sm font-light text-gray-500 truncate dark:text-gray-400">{additionalInfo[1]}</span>
        </div>}

        <DropDownItem elements={headerDropdown} onTrigger={handleTriggerHeader} />
        <DropDownItem elements={bodyDropdown} onTrigger={handleTriggerBody} />
        <DropDownItem elements={bottomDropdown} onTrigger={handleTriggerBottom} />

      </div>
    </div>
  );
}

export default DropDown;




